import { OverlayAnimation } from './optionsAnimation';

export const getAnimationProps = (animation: OverlayAnimation) => {
  switch (animation) {
    case 'None':
      return {};
    case 'bounce':
      return {
        initial: {
          opacity: 0,
          scale: 0.5,
        },
        animate: {
          opacity: 1,
          scale: 1,
          transition: {
            type: 'spring',
            duration: 0.75,
            bounce: 0.5,
          },
        },
        exit: {
          opacity: 0,
          scale: 0.5,
          transition: {
            duration: 0.25,
            bounce: 0.5,
          },
        },
      };
    case 'fade':
      return {
        initial: {
          opacity: 0,
        },
        animate: {
          opacity: 1,
          transition: {
            type: 'tween',
            duration: 0.75,
          },
        },
        exit: {
          opacity: 0,
          transition: {
            duration: 0.25,
          },
        },
      };
    case 'zoom':
      return {
        initial: {
          scale: 0,
        },
        animate: {
          scale: 1,
          transition: {
            duration: 0.5,
            type: 'tween',
          },
        },
        exit: {
          scale: 0,
          transition: {
            duration: 0.25,
          },
        },
      };
  }
};
